/**
 * ArrestTarget enum values.
 * Same as in ArrestTarget.php. Must be kept in sync!
 */
export enum ArrestTarget {
  EARREST = 'earrest',
  EPIS = 'epis',
}
